export const LOCAL_STORAGE = {
  TOKEN: 'token',
};

export const SESSION_STORAGE = {
  TOKEN: 'token',
};
